export { getConfig } from './src/odata-config.es';
